var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ArrowBack } from '@mui/icons-material';
import { Avatar, Chip, Divider } from '@mui/material';
import { CustomerEditIcon } from '../../../assets/customIcons';
import { ReactComponent as DownDoubleArrow } from '../../../assets/images/chevron-down-double.svg';
import { ReactComponent as LocationIcon } from '../../../assets/images/LocationIcon.svg';
import { ReactComponent as MailIcon } from '../../../assets/images/mailSvg.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { systemColor } from '../../../theme/systemColor';
import EditCustomerdetails from '../../customerV3/Pages/editCustomerdetails';
import { getAppointmentDetails, getCampaignList, getRepairTypeList } from '../services/apiCalls';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { ESystemName, LOCAL_STORAGE_KEYS } from '../../../constants';
import { USER_PROFILE_DATA } from '../../../api/url';
import { GalleryIconNew, GreenVerifiedTick, MicIconBlue, MoreIconGray } from '../../../assets/images';
var AppointmentDetail = function () {
    var _appointmentDetail$da, _appointmentDetail$da2, _customerInfo$Email, _userData$data, _userData$data2, _appointmentDetail$da4;
    var dispatch = useAppDispatch();
    var appointmentDetail = useAppSelector(function (state) { return state.crud; }).appointmentDetail;
    var customerInfo = appointmentDetail === null || appointmentDetail === void 0 || (_appointmentDetail$da = appointmentDetail.data) === null || _appointmentDetail$da === void 0 ? void 0 : _appointmentDetail$da.Customer;
    var vehicleDetail = appointmentDetail === null || appointmentDetail === void 0 || (_appointmentDetail$da2 = appointmentDetail.data) === null || _appointmentDetail$da2 === void 0 ? void 0 : _appointmentDetail$da2.Vehicle;
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var openEditProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Dialog',
                        Component: EditCustomerdetails,
                        containerProps: {
                            fullWidth: true,
                            maxWidth: 'sm'
                        }
                    }))];
                case 1:
                    result = _a.sent();
                    console.log(result === null || result === void 0 ? void 0 : result.payload);
                    return [2 /*return*/];
            }
        });
    }); };
    var genralTabDetails = [{
            type: FormItemTypes.CardComponent,
            label: 'Customer details',
            name: 'CustomerDetails',
            value: null,
            columnSize: 12,
            sx: {
                margin: '0px 24px'
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    label: '',
                    name: '',
                    value: null,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    elements: [{
                            type: FormItemTypes.Box,
                            label: '',
                            name: '',
                            value: null,
                            columnSize: 12,
                            display: 'flex',
                            flexDirection: 'row',
                            padding: 0,
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    label: '',
                                    name: '',
                                    value: null,
                                    xs: 3,
                                    sm: 1,
                                    md: 1.5,
                                    element: function () { /*#__PURE__*/ return React.createElement(Avatar, {
                                        sx: {
                                            height: '40px ',
                                            width: '40px'
                                        }
                                    }); }
                                }, {
                                    type: FormItemTypes.Box,
                                    label: '',
                                    name: '',
                                    value: null,
                                    xs: 9.5,
                                    sm: 11,
                                    md: 11.5,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            value: "".concat((customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.GivenName) || '', " ").concat((customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.FamilyName) || '').trim(),
                                            columnSize: 10,
                                            variant: 'h1',
                                            fontSize: '14px',
                                            fontFamily: 'NotoSans-Medium'
                                        }, {
                                            type: FormItemTypes.Box,
                                            name: '',
                                            columnSize: 12,
                                            display: 'flex',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.MobileNumber,
                                                    columnSize: 2,
                                                    variant: 'caption',
                                                    color: systemColor.lightGrey
                                                }, (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.IsMobileVerified) && {
                                                    type: FormItemTypes.Custom,
                                                    name: '',
                                                    element: function () { /*#__PURE__*/ return React.createElement("img", {
                                                        src: GreenVerifiedTick,
                                                        alt: "",
                                                        loading: "lazy",
                                                        style: {
                                                            marginTop: '5px'
                                                        }
                                                    }); }
                                                }]
                                        }]
                                }, {
                                    type: FormItemTypes.IconButton,
                                    label: '',
                                    name: '',
                                    value: null,
                                    columnSize: 1,
                                    children: /*#__PURE__*/ React.createElement(CustomerEditIcon, null),
                                    onClick: openEditProfile
                                }]
                        }, {
                            type: FormItemTypes.Box,
                            label: '',
                            name: '',
                            value: null,
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    label: '',
                                    name: '',
                                    value: null,
                                    columnSize: 12,
                                    element: function () { /*#__PURE__*/ return React.createElement(Divider, {
                                        sx: {
                                            marginInline: '-20px '
                                        }
                                    }); }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'Email',
                                    children: (_customerInfo$Email = customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.Email) !== null && _customerInfo$Email !== void 0 ? _customerInfo$Email : '-',
                                    value: null,
                                    columnSize: 12,
                                    startIcon: /*#__PURE__*/ React.createElement(MailIcon, {
                                        color: "#8593A3"
                                    }),
                                    sx: {
                                        color: 'gray'
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: '',
                                    value: null,
                                    columnSize: 12,
                                    startIcon: /*#__PURE__*/ React.createElement(LocationIcon, {
                                        height: '14px',
                                        width: '14px'
                                    }),
                                    children: 'Wagholi Pune',
                                    sx: {
                                        color: 'gray'
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    label: '',
                    name: '',
                    value: null,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    elements: [{
                            type: FormItemTypes.Box,
                            label: '',
                            name: '',
                            value: null,
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: '',
                                    value: vehicleDetail === null || vehicleDetail === void 0 ? void 0 : vehicleDetail.RegistrationNo,
                                    columnSize: 0,
                                    fontFamily: 'NotoSans-Medium',
                                    fontSize: '14px'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    value: vehicleDetail === null || vehicleDetail === void 0 ? void 0 : vehicleDetail.ProductName,
                                    columnSize: 0,
                                    variant: 'caption',
                                    color: systemColor === null || systemColor === void 0 ? void 0 : systemColor.lightGrey
                                }]
                        }, {
                            type: FormItemTypes.Box,
                            label: '',
                            name: '',
                            value: null,
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.CardComponent,
                                    name: '',
                                    label: '',
                                    value: false,
                                    columnSize: 12,
                                    elements: [{
                                            type: FormItemTypes.Box,
                                            name: 'Enginenobox',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    label: 'Engine No . :',
                                                    name: '',
                                                    value: null,
                                                    columnSize: 6
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'EngineNo',
                                                    value: vehicleDetail === null || vehicleDetail === void 0 ? void 0 : vehicleDetail.EngineNo,
                                                    columnSize: 6,
                                                    textAlign: 'end',
                                                    variant: 'subtitle2'
                                                }]
                                        }, {
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    label: 'Chassis No . :',
                                                    name: '',
                                                    value: null,
                                                    columnSize: 6
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: vehicleDetail === null || vehicleDetail === void 0 ? void 0 : vehicleDetail.VinNo,
                                                    columnSize: 6,
                                                    textAlign: 'end',
                                                    variant: 'subtitle2'
                                                }]
                                        }, {
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    label: 'Date of Sale. :',
                                                    name: '',
                                                    value: null,
                                                    columnSize: 6
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: vehicleDetail === null || vehicleDetail === void 0 ? void 0 : vehicleDetail.SalesInvoiceDate,
                                                    columnSize: 6,
                                                    textAlign: 'end',
                                                    variant: 'subtitle2'
                                                }]
                                        }]
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Service Details',
            name: 'ServiceDetails',
            value: null,
            columnSize: 12,
            sx: {
                margin: '0px 24px'
            },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    label: 'Service Type',
                    name: 'RepairTypeId',
                    value: null,
                    columnSize: 4,
                    xs: 12,
                    sm: 6,
                    required: true,
                    apiKey: 'repairTypeList',
                    apiRequest: {
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ModuleEntityId: ESystemName.Appointment
                    },
                    getListData: getRepairTypeList,
                    displayExpr: 'Name',
                    valueExpr: 'id'
                }, {
                    type: FormItemTypes.NumberInput,
                    label: 'Odometer Reading',
                    name: '',
                    value: null,
                    columnSize: 4,
                    xs: 12,
                    sm: 6,
                    required: true
                }, {
                    type: FormItemTypes.TextInput,
                    label: 'Service Advisor',
                    name: 'ServiceAdvisor',
                    value: "".concat((userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.GivenName) || '', " ").concat((userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.FamilyName) || '').trim(),
                    disabled: true,
                    xs: 12,
                    sm: 6,
                    columnSize: 4
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Other details',
            name: 'OtherDetails',
            value: null,
            columnSize: 12,
            sx: {
                margin: '0px 24px'
            },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    label: 'Campaign',
                    name: 'CampaignId',
                    value: null,
                    columnSize: 4,
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    getListData: getCampaignList,
                    apiRequest: {
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ModuleEntityId: null
                    },
                    apiKey: 'compaignList',
                    xs: 12,
                    sm: 6
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: '',
            name: 'ServiceDetails',
            value: null,
            columnSize: 12,
            sx: {
                margin: '0px 24px'
            },
            elements: [{
                    type: FormItemTypes.DatePicker,
                    label: 'Date & Time Slot',
                    name: 'DateAndTime',
                    value: null,
                    placeholder: 'Select date',
                    columnSize: 4,
                    disabled: true,
                    xs: 12,
                    sm: 6
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: '',
            name: 'ServiceDetails',
            value: null,
            columnSize: 12,
            sx: {
                margin: '0px 24px'
            },
            elements: [{
                    type: FormItemTypes.TextInput,
                    label: 'Customer Complaints',
                    name: 'CustomerComplaints',
                    value: null,
                    columnSize: 12,
                    minRows: 4,
                    multiline: true
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 12,
                    justifyContent: 'space-between',
                    display: 'flex',
                    elements: [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: 0.5,
                            xs: 2,
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.IconButton,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement("img", {
                                        src: GalleryIconNew,
                                        alt: ""
                                    }),
                                    columnSize: 1,
                                    xs: 1
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement("img", {
                                        src: MicIconBlue,
                                        alt: "",
                                        loading: "lazy"
                                    }),
                                    columnSize: 1,
                                    xs: 1
                                }]
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: 6,
                            xs: 10,
                            justifyContent: 'end',
                            alignItems: 'center',
                            textAlign: 'right',
                            elements: [{
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: 'Translate VOC To Job Items*',
                                    xs: 9,
                                    sm: 12,
                                    md: 4.5
                                }, {
                                    type: FormItemTypes.Custom,
                                    name: '',
                                    xs: 1.2,
                                    sm: 1.5,
                                    md: 0.5,
                                    element: function () { /*#__PURE__*/ return React.createElement(Chip, {
                                        label: "0",
                                        variant: "outlined",
                                        size: "small",
                                        color: "primary"
                                    }); }
                                }]
                        }]
                }]
        }];
    var steps = [{
            elements: genralTabDetails
        }, {
            elements: genralTabDetails
        }];
    var tabs = [{
            id: "0",
            label: "General"
        }, {
            id: "1",
            label: "Task details"
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            label: '',
            name: '',
            value: null,
            columnSize: 12,
            height: 'auto',
            justifyContent: 'space-between',
            padding: '0px 24px',
            marginTop: '5px',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    paddingLeft: '24px',
                    xs: 10,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'backBtn',
                            columnSize: 0,
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small"
                            })
                        }, {
                            type: FormItemTypes.Typography,
                            name: "header",
                            children: "Service Details",
                            columnSize: 11,
                            variant: "h1",
                            noWrap: true
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'end',
                    alignItems: 'center',
                    xs: 2,
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: 'backBtn',
                            columnSize: 0,
                            element: function () {
                                var _appointmentDetail$da3;
                                return /*#__PURE__*/ React.createElement(Chip, {
                                    variant: "outlined",
                                    color: "primary",
                                    label: appointmentDetail === null || appointmentDetail === void 0 || (_appointmentDetail$da3 = appointmentDetail.data) === null || _appointmentDetail$da3 === void 0 ? void 0 : _appointmentDetail$da3.StatusName,
                                    sx: {
                                        borderRadius: '8px'
                                    }
                                });
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: "showstatus",
                            children: /*#__PURE__*/ React.createElement(DownDoubleArrow, {
                                color: systemColor === null || systemColor === void 0 ? void 0 : systemColor.primary
                            }),
                            columnSize: 1
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: 'headerDetails',
                    columnSize: 12,
                    display: 'flex',
                    gap: '24px',
                    paddingLeft: '36px',
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Box,
                            name: 'headerDetailsbox',
                            md: 3,
                            sm: 12,
                            display: 'flex',
                            gap: '24px',
                            xs: 12,
                            justifyContent: 'space-between',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    label: 'APT. NO.',
                                    name: 'AptNo',
                                    children: appointmentDetail === null || appointmentDetail === void 0 || (_appointmentDetail$da4 = appointmentDetail.data) === null || _appointmentDetail$da4 === void 0 ? void 0 : _appointmentDetail$da4.SourceDocumentNo,
                                    value: null,
                                    columnSize: 12,
                                    width: 'content',
                                    xs: 6
                                }, {
                                    type: FormItemTypes.Typography,
                                    label: 'APT. DATE',
                                    name: 'AptDate',
                                    children: '6 Jan, 2025',
                                    value: null,
                                    columnSize: 12,
                                    alignItems: 'end',
                                    textAlign: {
                                        xs: 'end',
                                        md: 'start'
                                    },
                                    labelTypographyProps: {
                                        sx: {
                                            textAlign: {
                                                xs: 'end',
                                                md: 'start'
                                            }
                                        }
                                    }
                                }]
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'moreIcon',
                            columnSize: 0.2,
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: MoreIconGray,
                                alt: ""
                            })
                        }]
                }]
        }, {
            type: FormItemTypes.Custom,
            name: 'divider',
            columnSize: 12,
            containerProps: {
                padding: '0px'
            },
            element: function () { /*#__PURE__*/ return React.createElement(Divider, {
                sx: {
                    width: '100%'
                }
            }); }
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            label: "",
            value: null,
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            variant: 'scrollable',
            sx: {
                margin: '0px 24px'
            }
        }, {
            type: FormItemTypes.MobileStepper,
            name: "Stepper",
            label: "",
            value: null,
            steps: steps,
            columnSize: 12,
            sx: {
                margin: '0px  24px 24px 24px'
            }
        }];
    var id = 'bc7fd239-0bea-4aed-90b9-05326dbea5af';
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        getKey: "appointmentDetail",
        getRequest: {
            id: id
        },
        mode: "edit",
        getFormAPI: getAppointmentDetails,
        formProps: {
            bgcolor: '#f5f7fa'
        }
    });
};
export default AppointmentDetail;
